import React, { useRef } from 'react';
import HeroSection from '../components/HeroSection';
// import ExpandableBox from '../components/ExpandableBox';
import Slider from 'react-slick';
import placeholder from '../images/placeholder-connect.jpg';
import feature1 from '../images/feature1.jpg';
import feature2 from '../images/feature2.jpg';
import feature3 from '../images/feature3.jpg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HomePage.css';
import { Link } from 'react-router-dom';

function HomePage() {
  const howToMatchSectionRef = useRef(null);

  const scrollToHowToMatch = () => {
    howToMatchSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const sliderSettingsFeatures = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const androidLink = "https://play.google.com/store/apps/details?id=com.RoomEase.roomate&hl=en_IN";
  const iosLink = "https://apps.apple.com/my/app/roomease-roommate-finder/id6743614619";
  const whatsappCommunityLink = "https://chat.whatsapp.com/DjMMPhXmJvx7azSlRnky3c";

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let os = "unknown";

    if (/android/i.test(userAgent)) {
      os = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      os = "iOS";
    }

    // --- Facebook Pixel Tracking for Download App Click (bottom CTA) ---
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Homepage Bottom CTA Download App Button Click',
        source_os: os,
      });
      console.log(`Facebook Pixel: Lead event fired for Homepage Bottom CTA (${os}).`);
    } else {
      console.warn('Facebook Pixel: fbq not found, Homepage Bottom CTA event not tracked.');
    }
    // --- End Facebook Pixel Tracking ---

    if (os === "Android") {
      window.location.href = androidLink;
    } else if (os === "iOS") {
      window.location.href = iosLink;
    } else {
      window.location.href = "https://linktr.ee/roomeaseindia";
    }
  };

  return (
    <div className="home-page">
      <HeroSection />

      {/* Happy Customers Section */}
      <div className="happy-customers-section">
        <div className="container" style={{ background: 'linear-gradient(to top, #f0f8ff, #aaddff)', backgroundColor: "#f4f9fc" }}>
          <p className="happy-customers-text">Trusted by 3500+ users who've found a roommate for their 3AM thoughts and snacks. Find yours now!</p>
        </div>
      </div>

      {/* --- NEW SECTION FOR THE GOOGLE FORM --- */}
      <section className="google-form-section">
        <div className="container" style={{ backgroundColor: '#fff' }}>
          <h2>Looking for a PG in Delhi, Mumbai or other major cities?</h2>
          <p>Let RoomEase do the heavy lifting! Fill this 1-min form & we'll send you verified, comfortable, and budget-friendly options that match your vibe.</p>
          <Link to="/move-in" className="cta-button">
            Find Your Room Today
          </Link>
        </div>
      </section>

      {/* Section 1: Discover & Connect */}
      <div className="discover-section">
        <div className="container" style={{ backgroundColor: '#f4f9fc' }}>
          <div className="discover-text">
            <h2>Discover and Connect with Potential Roommates</h2>
            <p className="large-paragraph">RoomEase offers a seamless way to find people who match your lifestyle and preferences. Say goodbye to awkward interviews and endless searching. Our intelligent matching system does the hard work for you, so you can focus on connecting with individuals who could be your ideal roommate.</p>
            <button className="learn-more-button" onClick={scrollToHowToMatch}>Learn How It Works</button>
          </div>

          <div className="discover-image">
            <img src={placeholder} alt="Connect with Roommates" />
          </div>
        </div>
      </div>

      {/* Section 2: Key Features */}
      <section className="features-section">
        <div className="container" style={{ backgroundColor: 'white' }}>
          <h2>Key Features Designed for Easier Roommate Finding</h2>
          <Slider {...sliderSettingsFeatures}>
            <div className="feature-item-carousel">
              <img src={feature1} alt='detailed preference matching' className="feature-icon" />
              <h3>Detailed Preference Matching</h3>
              <p>Tell us about your lifestyle, habits, and preferences, and we'll find roommates who align with your criteria.</p>
            </div>

            <div className="feature-item-carousel">
              <img src={feature2} alt='swipe' className="feature-icon" />
              <h3>Intuitive Swipe Interface</h3>
              <p>Browse potential roommates effortlessly. Swipe right to express interest or left to move on.</p>
            </div>

            <div className="feature-item-carousel">
              <img src={feature3} alt='DMs' className="feature-icon" />
              <h3>Secure In-App Messaging</h3>
              <p>Connect and chat directly with potential roommates within the app to get to know them better.</p>
            </div>
          </Slider>
        </div>
      </section>

      {/* Section 3: How to Match with Your Ideal Roommate? */}
      <section className="how-to-match-section" ref={howToMatchSectionRef}>
        <div className="container" style={{ backgroundColor: '#fff' }}>
          <h2>How to Match with Your Ideal Roommate?</h2>
          <div className="steps-grid">
            <div className="step-item">
              <h3>Create a Profile</h3>
              <p>Start by building your personalized profile. Share your lifestyle, interests, and living preferences to help find your ideal roommate.</p>
            </div>

            <div className="step-item">
              <h3>Set your preferences</h3>
              <p>Customize your search with specific preferences like budget, location, and living habits to ensure the perfect match.</p>
            </div>

            <div className="step-item">
              <h3>Swipe and Match</h3>
              <p>Browse through potential roommates with ease! Swipe through profiles and connect with those who are the best fit for you.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Ready to Find Your RoomEase? */}
      <section className="cta-bottom-section">
        <div className="container" style={{ backgroundColor: '#e6f7fb', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2>Ready to Find Your Perfect RoomEase?</h2>
          <p className="large-paragraph">Join our growing community today and take the first step towards a harmonious living situation.</p>
          <button className="join-waitlist-cta-button" onClick={handleDownloadClick}>Download App</button>
          <a href={whatsappCommunityLink} target="_blank" rel="noopener noreferrer" className='whatsapp'>Join WhatsApp Community</a>
        </div>
      </section>
    </div>
  );
}

export default HomePage;